export { default as TelegramIcon } from "./telegram";
export { default as InstagramIcon } from "./instagram";
export { default as YouTubeIcon } from "./youtube";
export { default as FacebookIcon } from "./facebook";
export { default as MailIcon } from "./mail";
